import { Component, type ReactNode } from "react"
import { Link } from "react-router-dom"

import { Button } from "@/components/ui/button"

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children
    }

    return (
      <main
        id="main"
        className="mx-auto flex min-h-dvh w-full max-w-md flex-col bg-background text-foreground"
      >
        <header className="border-b-2 border-border px-5 py-5">
          <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-primary">
            Fault · 500
          </p>
          <h1 className="mt-2 font-mono text-2xl font-bold uppercase tracking-tight text-foreground">
            Something went wrong
          </h1>
        </header>
        <section className="flex-1 px-5 py-6">
          <div
            className="border-2 border-primary bg-card p-5"
            style={{ boxShadow: "var(--shadow-brutal)" }}
          >
            <p className="text-base text-foreground">
              We've reported the error. Return home and try again.
            </p>
          </div>
        </section>
        <div className="mt-auto px-5 py-5">
          <Button
            asChild
            className="h-14 w-full bg-primary text-primary-foreground hover:bg-primary"
          >
            <Link to="/">Return home ↗</Link>
          </Button>
        </div>
      </main>
    )
  }
}
